import { render, staticRenderFns } from "./SalaryDistChart.vue?vue&type=template&id=163a9db0&"
import script from "./SalaryDistChart.vue?vue&type=script&lang=js&"
export * from "./SalaryDistChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports